"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = Link;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const localized_path_1 = require("@src/shared/localized-path");
const use_redirect_to_account_if_logged_in_1 = require("@src/hooks/use-redirect-to-account-if-logged-in");
const react_scroll_1 = require("react-scroll");
const routesToCheckRedirect = [
    '/login',
    '/registracia',
    '/registration',
    '/registracia-uchadzac',
    '/registration-candidate',
    '/prihlasenie',
];
function Link(props) {
    const location = (0, react_router_dom_1.useLocation)();
    const language = (0, localized_path_1.getLanguageFromPathname)(location.pathname);
    const accountDestinationPath = (0, use_redirect_to_account_if_logged_in_1.useShouldRedirectToAccountIfLoggedIn)(props.to);
    if (props.to) {
        let destinationPath = props.to;
        if (routesToCheckRedirect.includes(props.to)) {
            destinationPath = accountDestinationPath;
        }
        return ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { onClick: location.pathname === (0, localized_path_1.getLocalizedPath)(destinationPath, language)
                ? () => {
                    react_scroll_1.animateScroll.scrollToTop();
                    return false;
                }
                : undefined, className: props.className, to: (0, localized_path_1.getLocalizedPath)(destinationPath, language), children: props.children }));
    }
    return ((0, jsx_runtime_1.jsx)("a", { className: props.className, onClick: props.onClick, href: props.href, children: props.children }));
}
